/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import delayAnalysisRoomSlice from './slice/roomSlices/delayAnalysisRoomSlice';
import workstationRoomSlice from './slice/roomSlices/workstationRoomSlice';
import topologyRoomSlice from './slice/roomSlices/topologyRoomSlice';
import exploreRoomSlice from './slice/roomSlices/exploreRoomSlice';
import { notSharedAction } from './constants/notSharedAction';
import { sendAction } from '../multiplayer/SocketConnection';
import jobRoomSlice from './slice/roomSlices/jobRoomSlice';
import centerGraphSlice from './slice/centerGraphSlice';
import { configureStore } from '@reduxjs/toolkit';
import privateSlice from './slice/privateSlice';
import homeSlice from './slice/roomSlices/homeSlice';
import userSlice from './slice/userSlice';
import roomSlice from './slice/roomSlice';
import claraSlice from './slice/claraSlice';
import { 
  DELAY_ANALISYS_ROOM,
  EXPLORE_ROOM, HOME_ROOM,
  JOB_ROOM, TOPOLOGY_ROOM,
  WORKSTATION_ROOM
} from '../rooms/RoomNameConstants';

export const shareActionsMiddleware = () => (next) => (action) => {
  // Here you have access to `action.type` and `action.payload`
  next(action)

  const inCooperative = store.getState().private.device.cooperative
  const roomId = store.getState().room?.roomId

  if (!action.remote && roomId && inCooperative && notSharedAction.every((slice) => !action.type.includes(slice)))
    sendAction(action, roomId)
}

const store = configureStore({
  reducer: {
    private: privateSlice.reducer,
    user: userSlice.reducer,
    centerGraph: centerGraphSlice.reducer,
    room: roomSlice.reducer,
    clara: claraSlice.reducer,
    [HOME_ROOM]: homeSlice.reducer,
    [DELAY_ANALISYS_ROOM]: delayAnalysisRoomSlice.reducer,
    [WORKSTATION_ROOM]: workstationRoomSlice.reducer,
    [TOPOLOGY_ROOM]: topologyRoomSlice.reducer,
    [EXPLORE_ROOM]: exploreRoomSlice.reducer,
    [JOB_ROOM]: jobRoomSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }).concat(shareActionsMiddleware)
});

export default store;